import React, { useState, useEffect, useRef, forwardRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { listsetting1, setMiniViewIds, useropen } from '../../redux/userInfo';
import { open, close, loadingflas, listupdater } from '../../redux/popupSlice';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Button from '../../component/Button';
import Select from '../../component/Select';
import Radios from '../../component/Radios';
import Input from '../../component/Input';
import ListsettingPop from '../../component/ListsettingPop';
import ProductDetailPop from '../../component/ProductDetailPop';
import ProductSendPop from '../../component/ProductSendPop';
import ProductTogetherPop from '../../component/ProductTogetherPop';

// 신규 컴포넌트
import SelectClick from '../../component/SelectClick';
import PlusMinusBox from '../../component/PlusMinusBox';
import MiniDetailPop from '../../component/MiniDetailPop';

// 신규 모듈
import { useMediaQuery } from 'react-responsive'

import { Map, DrawingManager, MarkerClusterer, MapMarker, CustomOverlayMap } from "react-kakao-maps-sdk"
import AddrSelector from '../../component/AddrSelector';
import * as APIS from "../../utils/service";

import {
    getMemberinfo, numFormat, useIntersectionObserver, polygon_point_check, filterItems, geKoreanNumber, koreaNumber
} from "../../utils/utils";
import Checkbox from '../../component/Checkbox';
import consts from '../../libs/consts';
import ProductDetailwrite from '../../component/ProductDetailwrite';
import { VirtuosoGrid } from 'react-virtuoso';

const { kakao } = window;



export default function MiniPageList({
    viewType,
    navigation,
    memberinfos,
    list,
    ceoUser,
    listloading,
    onCardClick = () => { }
}) {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const managerRef = useRef(null);
    const mapRef = useRef(null);
    const clusterer = useRef(null);
    const target = useRef(null);
    const leftdivref = useRef(null);

    const { configdata } = useSelector(s => s.configReducer);
    const { listupdate } = useSelector(s => s.popupReducer);
    const { userdata, companylogourl, miniViewIds } = useSelector(s => s.userInfo);

    const width = window.innerWidth;
    const height = window.innerHeight;
    const MIN_WIDTH = width / 2;

    const [detail, setdetail] = useState('');
    // const [viewIds, setViewIds] = useState([]); // 클릭해본 매물 리덕스로 대체

    // 반응형 설정
    const is830 = useMediaQuery({ query: "(max-width : 830px)" });

    // console.log('list ==>> ', list);

    // 타입 이름 변경 
    const changeTitle = (idx) => {
        let conf = configdata?.consts?.category_2_OptionConsts?.find((item) => (item?.idx * 1 === idx * 1))
        let changeName = conf.title
        if (conf.idx === 2) // 다세대
            changeName = "빌라·연립"
        if (conf.idx === 3) // 단독/다가구
            changeName = "원·투룸"
        if (conf.idx === 4) //주거 > 오피스텔
            changeName = "주거용 오피스텔"
        if (conf.idx === 8) //상업 > 오피스텔
            changeName = "업무용 오피스텔"

        return changeName
    }
    
    // 해시태그 붙이기
    const cardItemClick = (cardData) => {
        setdetail(cardData);
        onCardClick(cardData);
        
        // 이미 클릭한 매물 리덕스에 추가
        if (!miniViewIds.includes(cardData?.idx)) {
            // console.log(miniViewIds);
            // console.log(cardData?.idx);
            
            dispatch(setMiniViewIds(cardData?.idx))
        }

        //window.location.href = `#${cardData?.idx}`
        window.location.hash = `#detail${cardData?.idx}`;
    }

    useEffect(() => {
        if (!location.hash) {
            setdetail('');
        } else {
            let tagText = location.hash.replace("#", '');
            tagText = tagText.replace("detail", '');
            if(tagText === 'list') {
                setdetail('');
                return;
            }
            
            let cardIdx = Number(location.hash.replace("#detail", ''))

            if (!isNaN(cardIdx)) {
                let findIndex = list.findIndex(v => v.idx == cardIdx)
                if (findIndex >= 0) {
                    setdetail(list[findIndex]);
                } else {
                    setdetail('');
                }
            }
        }
    }, [location])

    const area_land_div = (title, m2, pyeong) => {
        return (
            <>
                {(is830 && viewType === 2) ? 
                    <div className='list_info_div'>
                        <p className='info'>{title}</p> 
                        <div className='list_is830_div'>
                            <p className='mm_info'>{m2}m²</p>
                            <p className='area_info'>(약 {pyeong}평)</p>
                        </div>
                    </div>
                    :
                    <div className='list_info_div'>
                        <p className='info'>{title}</p> 
                        <p className='mm_info'>{m2}m²</p>
                        <p className='area_info'>(약 {pyeong}평)</p>
                    </div>
                }
            </>
        )
    }

    return (
        <>
            <div className='mini_home_left'>
                {list?.length === 0 && listloading === false &&
                    <div className='mini_home_left_null'>

                        <div className='nolistArea'>
                            등록된 매물이 없습니다.
                        </div>
                    </div>
                }

                {listloading === true ?
                    <div style={{
                        width: '100%', height: 200,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        // backgroundColor: 'rgba(0,0,0,0.5)'
                    }}>
                        <img src={`${consts?.s3url}/${configdata?.loading_img}`} width={80} />
                    </div>
                    :
                    <VirtuosoGrid
                        style={{ height: "100%" }}
                        totalCount={list?.length}
                        components={{
                            List: forwardRef(({ style, children, ...props }, ref) => (
                                <div
                                    ref={ref}
                                    {...props}
                                    style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: viewType === 1 ? 20 : 15,
                                        ...style,
                                    }}
                                >
                                    {children}
                                </div>
                            )),
                            Item: ({ children, ...props }) => (
                                <div
                                    {...props}
                                    className={viewType === 1 ? 'mini_list_card_div' : 'mini_card_div'}
                                    onClick={() => {
                                        let itemData = list[props['data-index']]
                                        cardItemClick(itemData);
                                    }}
                                >
                                    {children}
                                </div>
                            )
                        }}

                        itemContent={(index) => {
                            const x = list[index]
                            let files = [];
                            x?.files?.map((x, i) => {
                                files.push(`${consts.s3url}/${x?.file_path}`);
                            });
                            return (
                                <>
                                    {/* 테스트 */}
                                    {/* {index} */}
                                    {viewType === 1 ? 
                                        <div className='list_view_card'>
                                            <div
                                                className='card_list_div_img'
                                                style={{
                                                    backgroundImage: 'url(' + files[0] + ')', backgroundSize: 'cover',
                                                    backgroundColor: '#FFF', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column',
                                                    zIndex: 999
                                                }}
                                            >
                                                {files?.length < 1 &&
                                                    <>
                                                        <p className='company-name'>{memberinfos?.compony?.title}</p>
                                                        {/* <p style={{ color: '#666666' }}>등록된 이미지가 없습니다.</p> */}
                                                    </>
                                                }
                                            </div>
                                            <div className='mini_list_card_content'>
                                                <div className=''>
                                                    <p className='main_list_card_title'>
                                                        {/* 업자 표기 변경 전 */}
                                                        {/* {configdata?.consts?.category_2_OptionConsts?.find((item) => (item?.idx * 1 === x['category_2'] * 1))?.title} */}
                                                        {changeTitle(x['category_2'])}
                                                    </p>

                                                    {/* 건물 구분 */}
                                                    {x['category_1'] * 1 === 3 ?
                                                        <div className='list_info_div_box'>
                                                            {area_land_div('연면적', x?.area_floor, (x?.area_floor * 0.3025).toFixed(1))}
                                                            {area_land_div('토지면적', x?.area_land, (x?.area_land * 0.3025).toFixed(1))}
                                                        </div>
                                                        :
                                                        <div>
                                                            <p className='info'>{String(x?.building_floor).replace("층", "")}층(총{x?.building_dong_floor_all}층)<span>·</span>전용{x?.area_private}m²(약 {(x?.area_private * 0.3025).toFixed(1)}평)</p>
                                                        </div>
                                                    }
                                                </div>
                                                

                                                {/* 텍스트만 표기 */}
                                                {/* <p className='price'>
                                                        {x?.sell_type === '월세' && `월세 ${numFormat(x?.price_all)} / ${numFormat(x?.price_month)}`}
                                                        {x?.sell_type === '매매' && `매매 ${numFormat(x?.price_sell)}`}
                                                        {x?.sell_type === '전세' && `전세 ${numFormat(x?.price_all)}`}
                                                    </p> */}
                                                    
                                                <p className='price flex'>
                                                    {x?.sell_type === '매매' && 
                                                        <>
                                                            <div className='seltype_status_box'>매매</div>
                                                            {` ${numFormat(x?.price_sell)}`}
                                                        </>
                                                    }
                                                    {x?.sell_type === '전세' && 
                                                        <>
                                                            <div className='seltype_status_box orange'>전세</div>
                                                            {` ${numFormat(x?.price_all)}`}
                                                        </>
                                                    }
                                                    {x?.sell_type === '월세' && 
                                                        <>
                                                            <div className='seltype_status_box green'>월세</div>
                                                            {` ${numFormat(x?.price_all)} / ${numFormat(x?.price_month)}`}
                                                        </>
                                                    }
                                                </p>

                                                {/* <div className='content'>
                                                    <p>{x?.itemdesc}</p>
                                                </div> */}
                                            </div>

                                            {miniViewIds?.includes(x?.idx) && <div className='corver' />}
                                        </div>
                                        :
                                        <>
                                            <div
                                                className='card_div_img'
                                                style={{
                                                    backgroundImage: 'url(' + files[0] + ')', backgroundSize: 'cover',
                                                    backgroundColor: '#FFF', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column',
                                                    position: 'relative',
                                                    zIndex: 1000
                                                }}
                                            >
                                                {files?.length < 1 &&
                                                    <>
                                                        <p className='company-name'>{memberinfos?.compony?.title}</p>
                                                        {/* <p style={{ color: '#666666' }}>등록된 이미지가 없습니다.</p> */}
                                                    </>
                                                }
                                            </div>
                                            <div className='mini_card_content'>
                                                <div>
                                                    <p className='mini_album_card_content'>
                                                        {/* 업자 표기 변경 전 */}
                                                        {/* {configdata?.consts?.category_2_OptionConsts?.find((item) => (item?.idx * 1 === x['category_2'] * 1))?.title} */}
                                                        {changeTitle(x['category_2'])}
                                                    </p>

                                                    {/* 건물 구분 */}
                                                    {x['category_1'] * 1 === 3 ?
                                                        <div className='album_info_div_box'>
                                                            {area_land_div('연면적', x?.area_floor, (x?.area_floor * 0.3025).toFixed(1))}
                                                            {area_land_div('토지면적', x?.area_land, (x?.area_land * 0.3025).toFixed(1))}
                                                        </div>
                                                        :
                                                        <p className='mini_album_info'>{String(x?.building_floor).replace("층", "")}층(총{x?.building_dong_floor_all}층)<span>·</span>전용{x?.area_private}m²(약 {(x?.area_private * 0.3025).toFixed(1)}평)</p>
                                                    }
                                                </div>
                                                

                                                {/* 텍스트만 표기 */}
                                                {/* <p className='price'>
                                                        {x?.sell_type === '월세' && `월세 ${numFormat(x?.price_all)} / ${numFormat(x?.price_month)}`}
                                                        {x?.sell_type === '매매' && `매매 ${numFormat(x?.price_sell)}`}
                                                        {x?.sell_type === '전세' && `전세 ${numFormat(x?.price_all)}`}
                                                    </p> */}

                                                <p className='price flex'>
                                                    {x?.sell_type === '매매' && <>
                                                        <div className='seltype_status_box'>매매</div>
                                                        {` ${numFormat(x?.price_sell)}`}
                                                    </>}
                                                    {x?.sell_type === '전세' && <>
                                                        <div className='seltype_status_box orange'>전세</div>
                                                        {` ${numFormat(x?.price_all)}`}
                                                    </>}
                                                    {x?.sell_type === '월세' && <>
                                                        <div className='seltype_status_box green'>월세</div>
                                                        {` ${numFormat(x?.price_all)} / ${numFormat(x?.price_month)}`}
                                                    </>}
                                                </p>

                                                {/* <div className='content'>
                                                    <p>{x?.itemdesc}</p>
                                                </div> */}
                                            </div>

                                            {miniViewIds?.includes(x?.idx) && <div className='corver' />}
                                        </>
                                    }
                                </>
                            )
                        }} />
                }
            </div>

            {detail &&
                <MiniDetailPop
                    row={detail}
                    memberinfos={memberinfos}
                    setClose={() => {
                        setdetail('');
                        navigate(-1)
                    }}

                // setproductdetailflag={setproductdetailflag} 
                // setproductsendflag={setproductsendflag} 
                // setproducttogetherflag={setproducttogetherflag}
                // productIdx={productIdx}
                // settogetherinfoData={settogetherinfoData}
                // setSendDatas={setSendDatas}

                />
            }
        </>
    )
}
